import { canUseDOM, format, injectScript, isBizNull } from "./dom";
import { S_LANG, webStorage } from "./webStorage";
import { getSwedenTime } from "./date-utils";
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { TweenMax, TimelineMax } from 'gsap';
import _ from "lodash";
import url from "url";
import querystring from "querystring";
import { getType } from "./obj-utils";
import { orderTypes, planType } from "./lynkco-constants";

let ScrollMagic;
export const loadScrollMagic = () => {
  if (!ScrollMagic) {
    ScrollMagic = require('scrollmagic');
    ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
  }
  return ScrollMagic;
};
export const comparisonString = (itemA, itemB) => {
  return itemA?.toLowerCase() === itemB?.toLowerCase();
};
export const mobileIs = () => {
  try {
    document.createEvent("TouchEvent"); return true;
  } catch(e) {
    return false; 
  }
};
export const birthdayUtils = {
  toString(time) {
    if (time) {
      return format(time, "yyyy/MM/dd");
    } else {
      return null;
    }
  },
  toData(date) {
    return getSwedenTime(date);
  }
};
export const formatDecimal = (num, decimal) => {
  // console.log(num)
  num = num.toString()
  let index = num.indexOf('.')
  if (index !== -1) {
      num = num.substring(0, decimal + index + 1)
  } else {
      num = num.substring(0)
  }
  return parseFloat(num).toFixed(decimal)
}
/**
 * determine whether the object is a Sitecore Object
 * @param {{fields:Object}} obj Sitecore Object
 * @return {boolean}
 */
export const isEmptyScObj = obj => {
  return getType(obj) !== "[object Object]" || isEmptyObject(obj.fields);
};
export const isEmptyObj = obj => {
  return getType(obj) !== "[object Object]" || isEmptyObject(obj);
};
export const isNumber = value => {
  return !isBizNull(value) && !isNaN(value);
};
export const isEmptyObject = obj => {
  if (obj === null || obj === undefined) {
    return true;
  }
  return Object.keys(obj).length === 0;
};

export const areEqualObjects = (obj1, obj2) => {
  if (!obj1 || !obj2 || typeof obj1 !== "object" || typeof obj2 !== "object") return false;
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (!keys1.length !== !keys2.length) return false;

  let isEqual = true;
  for (let index1 = 0; index1 < keys1.length; index1++) {
    if (!isEqual) break;

    const value2 = obj2[keys1[index1]],
      value1 = obj1[keys1[index1]];

    if (value1 !== value2) isEqual = false;
  }
  return isEqual;
};

export const getOverallSettingsStyles = fields => {
  const result = {};
  if (fields.backgroundColor?.fields) {
    const backgroundColor = fields.backgroundColor?.fields?.phrase?.value;
    if (/^#[0-9A-F]{6}|rgb?a/gi.test(backgroundColor)) {
      result.backgroundColor = fields.backgroundColor?.fields?.phrase?.value;
    } else {
      result.backgroundImage = fields.backgroundColor?.fields?.phrase?.value;
    }
  }
  return result;
};
export const getOverallSettingsClasses = fields => {
  if (getType(fields) !== "[object Object]") {
    return [];
  } else {
    const result = [];
    if (fields.alignment?.fields) {
      result.push(fields.alignment?.fields?.phrase?.value);
    }
    if (fields.paddingAboveBottom?.fields) {
      result.push(`padding-bottom-${fields.paddingAboveBottom.fields.phrase.value}`);
    }
    if (fields.paddingAboveTop?.fields) {
      result.push(`padding-top-${fields.paddingAboveTop.fields.phrase.value}`);
    }
    if (fields.theme?.fields) {
      result.push(`theme-${fields.theme.fields.phrase.value}`);
    }
    return result;
  }
};
export const componentId = rendering => `com-${rendering.uid.replace(/[{}]/g, '')}`;
export const distinct = (value, index, self) => {
  return self.indexOf(value) === index;
};
export const getSitecoreShortId = str => {
  return str.replace(/\{|\}|\-/g, "");
};
export const getSitecoreIdNoCurlyBrakets = str => {
  return str.replace(/\{|\}/g, "");
};
export const toLowerCaseHyphenated = str => {
  return str?.toLowerCase().replace(/ +/g, "-");
  // newStr = routeMethod.set(newStr);
  // return newStr;
};

export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};
export const isGlobalSite = () => {
  const lang = webStorage.get(S_LANG) || "en";
  return /^en$/gi.test(lang);
};
export const getCulture = () => {
  const lang = webStorage.get(S_LANG);
  const parts = lang.split("-");
  if (parts.length === 1) {
    return `${parts[0].toLowerCase()}-US`;
  } else {
    return `${parts[0].toLowerCase()}-${parts[1].toUpperCase()}`;
  }
};
export const formatLanguage = lang => {
  if (lang) {
    const parts = lang.split("-");
    return parts.length > 1 ? `${parts[0].toLowerCase()}-${parts[1].toUpperCase()}` : parts[0].toLowerCase();
  } else {
    return "en-US";
  }
};
export const selectFile = options => {
  const opts = _.merge({}, { accept: "image/*" }, options);
  return new Promise(resolve => {
    const el = document.createElement("input");
    el.type = "file";
    el.accept = opts.accept;
    el.style.position = "fixed";
    el.style.top = "-10000px";
    document.body.appendChild(el);
    el.click();
    el.addEventListener("change", evt => {
      resolve(el.files);
      document.body.removeChild(el);
    });
  });
};
export const formatSavedAddress = (address, showCountry) => {
  let name = `${address?.firstName || ""} ${address?.lastName || ""}`;
  let street = `${address?.street || ""} ${address?.apartment || ""}`;
  let zipCity = `${address?.postalCode || ""} ${address?.city || ""}`;
  let country = `${address?.country || ""}`;
  let result = [name, street, zipCity];
  if (showCountry) {
    result.push(country);
  }
  return result;
};
export const isBankCardExpired = (year, month) => {
  const judgeDate = new Date();
  judgeDate.setHours(judgeDate.getHours() + 12);
  const judgeYear = judgeDate.getFullYear();
  const judgeMonth = judgeDate.getMonth() + 1;
  return judgeYear > year || (judgeYear === year && judgeMonth > month);
};
export const trimMobile = mobile => {
  return Number(mobile).toString();
};
export const redirect = (history, href, replace = false) => {
  if (/^(https?|\/\/)/gi.test(href)) {
    window.location = href;
  } else {
    replace ? history.replace(href) : history.push(href);
  }
};
export function getPdpOrderType(pdpPlanType) {
  switch (pdpPlanType) {
    case planType.BaC:
      return orderTypes.buyACarCash;
    case planType.MtM:
      return orderTypes.monthToMonth;
    default:
      return null;
  }
}
export function getPdpPlanType(pdpSubType) {
  switch (pdpSubType) {
    case orderTypes.monthToMonth:
      return planType.MtM;
    case orderTypes.buyACarCash:
    case orderTypes.buyACarLoan:
      return planType.BaC;
    default:
      return null;
  }
}
export const getQuery = href => {
  if (href.indexOf("?") >= 0) {
    return querystring.parse(href.split("?")[1]);
  } else {
    return {};
  }
};
export const hasLink = href => {
  if (!canUseDOM()) {
    return false;
  }
  const currentPath = window.location.pathname.toLowerCase();
  const targetPath = url.parse(href).pathname.toLowerCase();
  return currentPath === targetPath;
};

export const genderTypeMapping = gender => {
  let genderType = "";
  switch (gender) {
    case "GENDER01":
      genderType = "Male";
      break;
    case "GENDER02":
      genderType = "Female";
      break;
    case "GENDER03":
    default:
      genderType = "";
      break;
  }
  return genderType;
};

export const html2Text = /**String*/ html => {
  const type = getType(html);
  if (isBizNull(html) || type !== "[object String]") {
    return null;
  }
  return html.replace(/<\/?(.|\s)*?>/g, "");
};

export const maskPhoneNumber = (phoneArea, phoneNumber) => {
  if (phoneNumber.length <= 3) {
    return phoneNumber[0] + "**";
  }
  return phoneArea + (phoneNumber ? phoneNumber[0] + phoneNumber[1] + "*".repeat(phoneNumber.length - 5) + phoneNumber.slice(-3) : null);
};

export const maskEmailAddress = email => {
  const [name, domain] = email.split("@");
  let maskedName;
  let slice = 1;
  if (name.length > 6) {
    slice = 3;
  }
  maskedName = name.slice(0, slice) + "*".repeat(name.length - slice);
  return maskedName + "@" + domain;
};
const language = 'en-US';
export const loadGMap = lang => {
  return new Promise(resolve => {
    if (!canUseDOM()) {
      resolve(null);
      return;
    }
    if (window.google?.maps) {
      resolve(window.google.maps);
      return;
    }
    const method = `onGMapReady${Math.ceil(Math.random() * 100000)}${Date.now()}`;
    window[method] = () => {
      resolve(window.google.maps);
    };
    injectScript(`https://maps.google.com/maps/api/js?key=AIzaSyAwZ2Q6kigLxECNaSF7AdeYL10wreHFt7g&callback=${method}&language=${language}`).catch(() => {
      resolve(null);
    });
  });
};

export const getSitecoreComponentId = props => {
  const { page, rendering } = props;
  // console.log("props", props);
  return `${page.name}-${rendering.dataSource.substr(1, rendering.dataSource.length - 2).toLowerCase()}`;
};

export const getQueryVariable = (variable) => {
  let query = window.location.search.substring(1);
  let vars = query.split("&");
  for (let i=0;i<vars.length;i++) {
    let pair = vars[i].split("=");
    if(pair[0] == variable){return pair[1];}
  }
  // return(false);
}

export const normalizeHref = href => href?.replace(/^\/en(?=\/|$)/, '');